import { FileTypeEnum } from 'api/enums';
import { IFeature } from 'api/models';
import { getFeatureCoverFile } from '../feature-announcement.utils';

interface FeatureMediaProps {
    feature: IFeature;
    className?: string;
    controls?: boolean;
}

const FeatureMedia = ({ feature, className = '', controls = true }: FeatureMediaProps) => {
    const file = getFeatureCoverFile(feature);
    const source = feature.coverImageUrl || file?.url;

    if (!source) return null;

    if (file?.type === FileTypeEnum.VIDEO) {
        return (
            <video
                src={source}
                aria-label={file.name || feature.title}
                className={className}
                controls={controls}
                muted={!controls}
                playsInline
                preload="metadata"
            />
        );
    }

    return <img src={source} alt={file?.name || feature.title} className={className} />;
};

export default FeatureMedia;
